/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CopyAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconCopyFilled from 'DesignSystem/Svgs/TysiaIconCopyFilled/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function CopyAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/CollectionLabel/Content/Content/CopyAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<button
  data-testid="CopyAction.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 title="Copy Transaction ID"
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconCopyFilled
  viewPath={`${viewPath}/TysiaIconCopyFilled`}
 fill2={dtColorsNeutral400}
 height={12}
 width={12}
/>
</button>
{children}
</React.Fragment>)
}